export const userSchema = {
  description: 'Validating User Input',
  type: 'object',
  properties: {
    firstname: {
      type: 'string',
      minLength: 1,
    },
    lastname: {
      type: 'string',
      minLength: 1,
    },
    phone: {
      type: 'string',
      pattern: '^[0-9]{10}$',
    },
    driverId: {
      type: 'string',
    },
    pfjMyRewardsNumber: {
      type: 'string',
      pattern: '^(?:[0-9]{0}|[0-9]{14})$',
    },
  },
};
